exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mz-card-content {\n  width: 100px;\n  height: 100px; }\n\n.card ::ng-deep .card-content {\n  padding: 0;\n  font-size: 80%; }\n\n.col-title p {\n  font-size: 1em; }\n\napp-annotationtype-display img.img-annotation-type-detail {\n  height: 40px;\n  padding: 2px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/annotationtype-display/annotationtype-display.component.scss
// module id = ../../../../../src/app/components/annotationtype-display/annotationtype-display.component.scss
// module chunks = main